import api from "../api"; // Importa o axios configurado

/**
 * Exclui um cliente no banco de dados
 * @param {number} idCliente - ID do cliente a ser excluído
 * @returns {Promise<Object>} - Resposta do backend
 */
export async function excluirCliente(idCliente) {
  try {
    const response = await api.delete(`/cliente/excluir.php`, {
      headers: {
        "Content-Type": "application/json",
      },
      data: { id: idCliente } // Passa o ID do cliente no corpo da requisição
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao excluir cliente:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}

/**
 * Atualiza um cliente no banco de dados
 * @param {Object} dadosCliente - Dados do cliente a serem atualizados
 * @returns {Promise<Object>} - Resposta do backend
 */
export async function atualizarCliente(dadosCliente) {
  try {
    const response = await api.put(`/cliente/alterar.php`, dadosCliente, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar cliente:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}

/**
 * Insere um novo cliente no banco de dados
 * @param {Object} dadosCliente - Dados do cliente a serem salvos
 * @returns {Promise<Object>} - Resposta do backend
 */
export async function inserirCliente(dadosCliente) {
  try {
    const response = await api.post("/cliente/inserir.php", dadosCliente, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao inserir cliente:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}

/**
 * Lista todos os clientes cadastrados no banco de dados
 * @returns {Promise<Object>} - Lista de clientes
 */
export async function listarClientes() {
  try {
    const response = await api.get("/cliente/listar.php", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao listar clientes:", error);

    if (error.response && error.response.data) {
      throw error.response.data;
    }

    throw new Error("Erro ao conectar com o servidor.");
  }
}
